<script lang="ts">

    import {NvbsSearchEngineApi} from "./NvbsSearchEngineApi/NvbsSearchEngineApi";
    import Lightbox from "./components/Lightbox.svelte";
    import {getContext} from "svelte";
    import type {MeResponse} from "./NvbsSearchEngineApi/interfaces";
    import MembershipNotice from "./components/MembershipNotice.svelte";
    import Svg from "./common/Svg.svelte";
    import {DetailSizePresets, GetDetailSize} from "./common/ImageSizePresets";

    let detailSize = $state(DetailSizePresets.default);

    let {
        data,
        thumbnail,
        file,
        category,
        onback,
        onprev = () => {
        },
        onnext = () => {
        },
        hasPrev = false,
        hasNext = false,
        lightboxOpen = $bindable(false),
        currentUser = $bindable(),
        copyrighturl
    }: {
        data: {
            id: number;
            [key: string]: string | string[] | null | number;
        };
        thumbnail: {
            png: string;
            webp: string;
        } | null;
        file: string;
        category: string;
        onback: () => void;
        onprev: () => void;
        onnext: () => void;
        hasPrev?: boolean;
        hasNext?: boolean;
        lightboxOpen?: boolean;
        currentUser?: MeResponse;
        copyrighturl: string;
    } = $props();

    let displayData = $state<[string, string][]>([]);
    let showPremiumPopup = $state(false);

    let categoriesWithPremiumCheck = [
        'nvbsodr',
        'nvbsbld',
        'nvbstop',
        'nvbsbti'
    ];


    $effect(() => {
        const d = {...data} as { [key: string]: string | string[] | null };
        const skip_keys = ['id', 'created_at', 'updated_at', 'tijdschrift', 'typebijdrage'];
        displayData = Object.entries(d).map(([key, value]) => {
            if (skip_keys.includes(key)) {
                return null;
            }
            if (key === 'date_one') {
                return ["Datum", new Date(value as string).toLocaleDateString('nl-NL')];
            }

            if (key === 'date_two') {
                return ["Datum", new Date(value as string).toLocaleDateString('nl-NL')];
            }

            if (key === 'jaarnummer') {
                return ["Jaar-Nummer", value as string];
            }

            if (Array.isArray(value)) {
                return [key, value.join(", ")];
            }
            if (value === null) {
                return [key, ""];
            }
            return [key, value];
        }).filter((item) => item !== null) as [string, string][];
    });

    let is_image = $state(false);

    let file_url = $derived.by(() => {
        return NvbsSearchEngineApi.getFileUrl(category, data.id);
    })

    $effect(() => {
        const is_image_regx = /\.(jpg|jpeg|png|gif)$/i;
        is_image = is_image_regx.test(file);
    })

    $effect(() => {
        detailSize = GetDetailSize(category);
    })

    function closePremiumPopup() {
        showPremiumPopup = false;
    }

    function premiumCheck() {
        if (categoriesWithPremiumCheck.indexOf(
            category.toLowerCase()
        ) === -1) {
            return true;
        }

        if (!currentUser.has_premium) {
            //TODO: Maak een pagina hiervoor.
            showPremiumPopup = true;
            return false;
        }

        return true;
    }

    function image_click() {
        if (!is_image) {
            openFile()
            return;
        }

        if (!premiumCheck()) {
            return;
        }

        lightboxOpen = true;
    }

    function openFile() {
        if (!premiumCheck()) {
            return;
        }

        window.open(file_url, '_blank');
    }

    function copy_link() {
        const url = new URL(window.location.href);

        const targetUrl = url.origin + url.pathname + window.location.search

        // write it to the clipboard
        navigator.clipboard.writeText(targetUrl).then(() => {
            alert("Link gekopieerd naar klembord!");
        }).catch(err => {
            console.error('Fout bij het kopiëren van de link: ', err);
        });
    }

    let can_share = getContext("can-share") ?? false;
    let is_mobile = getContext("is-mobile") ?? false;

    function share() {
        if (!can_share) {
            // copy link
            copy_link();
            return;
        }
        navigator.share({
            url: window.location.href,
        }).then(() => {
            console.log("Content shared successfully");
        }).catch((error) => {
            console.error("Error sharing content: ", error);
        });
    }

</script>

{#if showPremiumPopup}
    <MembershipNotice
            IsOpen={showPremiumPopup}
            onClose={closePremiumPopup}
    />
{:else }


    {#if data}
        <div class="post-detail">
            <div class="thumbnail"
                 style="--image-size: {detailSize}px"

                 onclick={image_click}
            >
                {#if thumbnail}
                    <img
                            src={thumbnail.webp}
                            class:pointer-cursor={is_image}
                            alt="Thumbnail"
                    />
                {/if}
            </div>

            <table>
                <tbody>
                {#each displayData as [key, value]}
                    {#if value.length > 0}
                        <tr>
                            <td>
                                <b class="post-data-title">
                                    {key}:
                                </b>
                            </td>

                            <td>{value}</td>
                        </tr>
                    {/if}
                {/each}
                </tbody>
            </table>

            <div class="buttons">
                <button class="btn-primary" disabled={!hasPrev} onclick={onprev}>Vorige</button>
                <button class="btn-primary" onclick={onback}>Terug</button>
                <button class="btn-primary" disabled={!hasNext} onclick={onnext}>Volgende</button>
                {#if is_mobile}
                    <button class="btn-primary" onclick={share}>Delen</button>
                {/if}
            </div>
        </div>

        <Lightbox
                src={file_url ?? thumbnail.webp}
                bind:open={lightboxOpen}
                canZoom={category === "nvbstop"}
                {hasNext}
                {hasPrev}
                onprev={() => {
                        onprev();
                  }}
                onnext={() => {
                      onnext();
                  }}
        />
    {/if}
    {#if ['nvbsbld', 'nvbstop'].includes(category.toLowerCase()) }
        <div class="copyright-notice">
            <p>
                © Collectie: Stichting NVBS-Railverzamelingen.
                <a href={copyrighturl} target="_blank"
                   aria-label="More information"
                   class="search-info-link"
                >
                    <Svg type="info-circle"/>
                </a>
            </p>
        </div>
    {/if}
{/if}

<style lang="scss">
  img {
    pointer-events: none;
  }

  .post-detail {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    table {
      height: fit-content;
      width: auto;
      flex: 1;

      tbody tr td:first-child {
        text-align: end;
        vertical-align: top;

        * {
          text-align: end;
          justify-content: end;
        }
      }
    }

    .thumbnail {
      width: fit-content;

      img {
        width: var(--image-size);
      }
    }

    ul {
      flex: 1;
      list-style-type: none;
    }

    .post-data-title {
      text-transform: capitalize;
      display: flex;
      min-width: max-content;
    }

    .buttons {
      width: fit-content;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 10px;

      button {
        width: 100%;

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          pointer-events: none;
        }
      }

      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }

  .pointer-cursor {
    cursor: pointer;
  }


  @media (max-width: 768px) {
    .post-detail {
      flex-direction: column;
      align-items: flex-start;

      .thumbnail {
        img {
          width: 100%;
        }
      }

      .buttons {
        flex-direction: row;
      }

      ul {
        padding: 0;
        margin: 0;
        order: 1000;
      }
    }
  }
</style>
